<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-4">
      <b-form-fieldset v-bind:label="$t('NAME')">
        <inputvalidation :formerror="formError" name="name">
          <b-form-input type="text" v-model="formData.name"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-4">
      <b-form-fieldset v-bind:label="$t('SURNAME')">
        <inputvalidation :formerror="formError" name="surname">
          <b-form-input type="text" v-model="formData.surname"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-4">
      <b-form-fieldset v-bind:label="$t('BIRTHDATE')">
        <inputvalidation :formerror="formError" name="birthDate">
          <lb-vue-datetimepicker
            type="date"
            v-model="formData.birthDate"
            :translate-method="translateDateTimePicker"
            format="YYYY-MM-DD"
            display-format="DD.MM.YYYY"
            :simple="true">
            </lb-vue-datetimepicker>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-4">
      <b-form-fieldset v-bind:label="$t('ADDRESS')">
        <inputvalidation :formerror="formError" name="address">
          <b-form-input type="text" v-model="formData.address"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-4">
      <b-form-fieldset v-bind:label="$t('PLACE')">
        <inputvalidation :formerror="formError" name="place">
          <b-form-input type="text" v-model="formData.place"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-4">
      <b-form-fieldset v-bind:label="$t('PHONENUMBER')">
        <inputvalidation :formerror="formError" name="phoneNumber">
          <b-form-input type="text" v-model="formData.phoneNumber"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
      <div class="col-sm-2">
          <inputvalidation :formerror="formError" name="isAdult">
              <label class="custom-label">{{$t('ISCONSULTANT')}}</label>
              <b-form-checkbox
                  plain
                  v-model="formData.isConsultant"
                  name="isConsultant"
                  :value="1"
                  :unchecked-value="0"
              >
              </b-form-checkbox>
          </inputvalidation>
      </div>
    <div class="col-sm-2">
        <inputvalidation :formerror="formError" name="isAdult">
        <label class="custom-label">{{$t('ISADULT')}}</label>
            <b-form-checkbox
                plain
                v-model="formData.isAdult"
                name="isAdult"
                :value="1"
                :unchecked-value="0"
                >
            </b-form-checkbox>
        </inputvalidation>
    </div>
    <div class="col-sm-2">
        <inputvalidation :formerror="formError" name="addNewParent">
        <label class="custom-label">{{$t('ADDNEWPARENT')}}</label>
            <b-form-checkbox
                :disabled="(formData != null && formData.childId != null) ? true : false"
                plain
                v-model="addNewParent"
                name="addNewParent"
                :value="1"
                :unchecked-value="0"
                >
            </b-form-checkbox>
        </inputvalidation>
    </div>
    <div class="col-sm-6" v-if="addNewParent == 0">
      <b-form-fieldset v-bind:label="$t('PARENT')">
        <inputvalidation :formerror="formError" name="parentId">
             <lb-vue-select v-model= "formData.parentIds"
                            :list= "parents.root"
                            :totalCount= "parents.totalCount"
                            :pagination= "pagination"
                            display-field= "fullName"
                            value-field= "childId"
                            multiselect="true"
                            :search-placeholder= "$t('SEARCH')"
                            :items-placeholder= "$t('PARENTS')">
              </lb-vue-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div v-if="addNewParent == 1">
    <div class="form-row mb-lg">
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('PARENTCHILDNAME')">
            <inputvalidation :formerror="formError" name="name">
              <b-form-input type="text" v-model="formData.parent_name"></b-form-input>
            </inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('PARENTCHILDSURNAME')">
            <inputvalidation :formerror="formError" name="surname">
              <b-form-input type="text" v-model="formData.parent_surname"></b-form-input>
            </inputvalidation>
          </b-form-fieldset>
        </div>
        <div class="col-sm-4">
          <b-form-fieldset v-bind:label="$t('PARENTBIRTHDATE')">
            <inputvalidation :formerror="formError" name="birthDate">
              <lb-vue-datetimepicker
                type="date"
                v-model="formData.parent_birthDate"
                :translate-method="translateDateTimePicker"
                format="YYYY-MM-DD"
                display-format="DD.MM.YYYY"
                :simple="true">
                </lb-vue-datetimepicker>
            </inputvalidation>
          </b-form-fieldset>
        </div>
      </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-4">
      <b-form-fieldset v-bind:label="$t('STATUS')">
        <inputvalidation :formerror="formError" name="status">
             <lb-vue-select v-model= "formData.status"
                            :list= "status"
                            display-field= "text"
                            value-field= "value">
              </lb-vue-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-4">
      <b-form-fieldset v-bind:label="$t('DIAGNOSE')">
        <inputvalidation :formerror="formError" name="diagnoseId">
             <lb-vue-select v-model= "formData.diagnoseId"
                            :list= "diagnose.root"
                            :totalCount= "diagnose.totalCount"
                            :pagination= "diagnosepagi"
                            display-field= "name"
                            value-field= "diagnoseId"
                            multiselect="true"
                            :search-placeholder= "$t('SEARCH')"
                            :items-placeholder= "$t('DIAGNOSE')">
              </lb-vue-select>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-4">
        <b-form-fieldset v-bind:label="$t('USERS')">
          <inputvalidation :formerror="formError" name="userId">
              <lb-vue-select v-model= "formData.userId"
                              :list= "users.root"
                              :totalCount= "users.totalCount"
                              display-field= "username"
                              value-field= "userId"
                              :search-placeholder= "$t('SEARCH')"
                              :items-placeholder= "$t('USERS')">
                </lb-vue-select>
          </inputvalidation>
        </b-form-fieldset>
      </div>
  </div>
  <div class="form-row mb-4">
    <div class="col-sm-3">
      <b-form-fieldset v-bind:label="$t('ALLERGIES')">
        <inputvalidation :formerror="formError" name="allergies">
          <b-form-input type="text" v-model="formData.allergies"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-1">
        <inputvalidation :formerror="formError" name="isKindergarten">
        <label class="custom-label">{{$t('ISKINDERGARTEN')}}</label>
            <b-form-checkbox
                plain
                v-model="formData.isKindergarten"
                name="checkboisKindergarten"
                value="1"
                unchecked-value="0"
                >
            </b-form-checkbox>
        </inputvalidation>
    </div>
    <div class="col-sm-4" v-if="formData.isKindergarten == 1">
      <b-form-fieldset v-bind:label="$t('KINDERGARTENNAME')">
        <inputvalidation :formerror="formError" name="kindergartenName">
          <b-form-input type="text" v-model="formData.kindergartenName"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-4" v-if="formData.isKindergarten == 1">
      <b-form-fieldset v-bind:label="$t('KINDERGARTENNAME')">
        <b-form-select v-model="formData.kindergartenName" class="mb-3">
          <b-form-select-option value="OŠ Eugena Kvaternika">OŠ Eugena Kvaternika</b-form-select-option>
          <b-form-select-option value="OŠ Eugena Kumičića">OŠ Eugena Kumičića</b-form-select-option>
          <b-form-select-option value="OŠ Jurja Habdelića">OŠ Jurja Habdelića</b-form-select-option>
          <b-form-select-option value="OŠ Nikole Hribara">OŠ Nikole Hribara</b-form-select-option>
          <b-form-select-option value="OŠ Vukovina">OŠ Vukovina</b-form-select-option>
          <b-form-select-option value="OŠ Novo Čiče">OŠ Novo Čiče</b-form-select-option>
          <b-form-select-option value="OŠ Velika Mlaka">OŠ Velika Mlaka</b-form-select-option>
          <b-form-select-option value="OŠ Kravarsko">OŠ Kravarsko</b-form-select-option>
        </b-form-select>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-4">
    <div class="col-sm-2">
        <inputvalidation :formerror="formError" name="isPsychiatrist">
        <label class="custom-label">{{$t('ISPSYCHIATRIST')}}</label>
            <b-form-checkbox
                plain
                v-model="formData.isPsychiatrist"
                name="checkboisPsychiatrist"
                value="1"
                unchecked-value="0"
                >
            </b-form-checkbox>
        </inputvalidation>
    </div>
    <div class="col-sm-10" v-if="formData.isPsychiatrist == 1">
      <b-form-fieldset v-bind:label="$t('PSYCHIATRISTNAME')">
        <inputvalidation :formerror="formError" name="psychiatristName">
          <b-form-input type="text" v-model="formData.psychiatristName"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('CLASSNUMBER')">
        <inputvalidation :formerror="formError" name="classNumber">
          <b-form-input type="text" v-model="formData.classNumber"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('REGISTRATIONNUMBER')">
        <inputvalidation :formerror="formError" name="registrationNumber">
          <b-form-input type="text" v-model="formData.registrationNumber"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('ANAMNESTICFORM')">
        <wysiwyg v-model="formData.anamnestic"/>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('COMMUNICATIONFORM')">
        <wysiwyg v-model="formData.communication"/>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('INSTRUMENTFORM')">
        <wysiwyg v-model="formData.instrument"/>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('OPINIONFORM')">
        <wysiwyg v-model="formData.opinion"/>
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';
import ParentsApi from '@/api/parents/ParentNew';
import UsersApi from '@/api/admin/Users';
import DiagnoseApi from '@/api/diagnose/Diagnose';

export default
{
    name: 'ChildForm',
    props: ['formData', 'formError'],
    data()
    {
        const me = this;
        return {
            parents:
      {},
            addNewParent: 0,
            users: {},
            diagnose: {},
            status:
      [
          {
              value: 'active',
              text: me.$i18n.t('ACTIVE'),
          },
          {
              value: 'inactive',
              text: me.$i18n.t('INACTIVE'),
          },
      ],
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          initialId: [],
          searchTimeout: false,
      },
            diagnosepagi:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          initialId: [],
          searchTimeout: false,
      },
        };
    },
    created()
    {
        const me = this;
        if (me.formData.userId == null)
        {
            me.formData.userId = me.globals.userId;
        }
        me.getParents();
        me.getDiagnose();
        me.getUsers();
    },
    methods:
  {
      translateDateTimePicker(val)
      {
          const me = this;
          return me.$t(val.toUpperCase());
      },
      async getParents()
      {
          const me = this;
          try
          {
              const data = await ParentsApi.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              for (const item of data.root)
              {
                  item.fullName = `${item.name} ${item.surname}`;
              }

              me.parents = data;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async getDiagnose()
      {
          const me = this;
          try
          {
              const data = await DiagnoseApi.selectRow(me.getDiagnoseParams);
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              me.diagnose = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      async getUsers()
      {
          const me = this;
          try
          {
              const data = await UsersApi.selectRow();
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              for (let i = 0; i < data.root.length; i += 1)
              {
                  data.root[i].password = '';
                  data.root[i].trhidden = false;
              }

              me.users = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
  },
    watch:
  {
      'pagination.limit'()
      {
          const me = this;
          me.getParents();
      },
      'pagination.currentPage'()
      {
          const me = this;
          me.getParents();
      },
      'pagination.query'()
      {
          const me = this;
          me.getParents();
      },
      'diagnosepagi.limit'()
      {
          const me = this;
          me.getDiagnose();
      },
      'diagnosepagi.currentPage'()
      {
          const me = this;
          me.getDiagnose();
      },
      'diagnosepagi.query'()
      {
          const me = this;
          me.getDiagnose();
      },
  },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParams()
      {
          const me = this;
          const data = {
              ...me.pagination,
          };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      getDiagnoseParams()
      {
          const me = this;
          const data = {
              ...me.pagination,
          };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
